import { Routes } from '@angular/router';
import { FormularioComponent } from './formulario/formulario.component';

export const routes: Routes = [
    { path: '' , component:FormularioComponent},
    { path: 'landing/:id' , component:FormularioComponent},
    { path: '**', pathMatch: 'full', redirectTo: '' },
];
